<template>
  <div class="IndexNumber">
    <div class="box">
      <div class="flex flex-wrap between">
        <dl v-for="(metric, index) in keyMetrics" :key="index">
          <dt>{{ metric.stat_value }}<em>{{ metric.stat_unit }}</em></dt>
          <dd>{{ metric.label }}</dd>
        </dl>
      </div>
    </div>
  </div>
</template>

<script>
import { getKeyMetric } from '@/api/request.js';

export default {
  name: 'TotalLine',
  data() {
    return {
      keyMetrics: [],
      loading: false,
      error: null
    };
  },
  async mounted() {
    await this.fetchKeyMetrics();
  },
  methods: {
    async fetchKeyMetrics() {
      try {
        this.loading = true;
        this.error = null;
        const response = await getKeyMetric();

        // 根据API文档，数据在response.list中
        if (response && response.list && Array.isArray(response.list)) {
          // 过滤激活的指标并按sort_order排序
          this.keyMetrics = response.list
            .filter(metric => metric.is_active === 1)
            .sort((a, b) => a.sort_order - b.sort_order);
        } else {
          // 如果API返回的数据结构不同，直接使用response
          this.keyMetrics = Array.isArray(response) ? response : [];
        }

        // 如果没有获取到数据，使用默认数据
        if (this.keyMetrics.length === 0) {
          this.setDefaultMetrics();
        }
      } catch (error) {
        console.error('获取关键指标数据失败:', error);
        this.error = error.message;
        // 出错时使用默认数据
        this.setDefaultMetrics();
      } finally {
        this.loading = false;
      }
    },
    setDefaultMetrics() {
      // 设置默认的关键指标数据作为后备方案
      this.keyMetrics = [
        {
          label: '成立至今',
          stat_value: '10',
          stat_unit: '年',
          sort_order: 10
        },
        {
          label: '分布国家',
          stat_value: '10',
          stat_unit: '+',
          sort_order: 20
        },
        {
          label: '可回收',
          stat_value: '100',
          stat_unit: '%',
          sort_order: 30
        },
        {
          label: '可降解',
          stat_value: '100',
          stat_unit: '%',
          sort_order: 40
        },
        {
          label: '已服务家庭数量',
          stat_value: '200万',
          stat_unit: '+',
          sort_order: 50
        }
      ];
    }
  }
};
</script>

<style scoped>
/* Add any specific styles for IndexNumber if needed */
</style>